import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ShieldCheck } from 'lucide-react';
import { CountdownBar } from './CountdownBar';
export function SalesSection() {
  return <section id="comprar" className="py-12 md:py-16" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-197">
      <div className="container mx-auto px-4" data-id="element-198">
        <div className="max-w-md mx-auto" data-id="element-199">
          <FadeIn data-id="element-200">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-t-4" style={{
            borderColor: 'var(--color-gold)'
          }} data-id="element-201">
              <div className="px-7 py-6 text-center" style={{
              background: 'linear-gradient(135deg, var(--color-sky-light) 0%, var(--color-sky-mid) 100%)'
            }} data-id="element-202">
                <h2 className="text-2xl font-bold mb-1" style={{
                color: 'var(--color-deep-blue)'
              }} data-id="element-203">
                  Accedé hoy a la colección completa
                </h2>
                <p className="text-sm font-bold uppercase tracking-wider mt-2" style={{
                color: 'var(--color-gold)'
              }} data-id="element-204">
                  Todo en un solo pack digital
                </p>
              </div>

              <div className="px-7 py-8 text-center" data-id="element-205">
                <CountdownBar variant="inline" data-id="element-206" />

                <div className="mb-6" data-id="element-207">
                  <span className="text-base line-through opacity-50 font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-208">
                    Antes $39.990 ARS
                  </span>
                  <div className="flex items-baseline justify-center gap-1.5 mt-1" data-id="element-209">
                    <span className="text-6xl font-extrabold tracking-tight" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-210">
                      $19.990
                    </span>
                    <span className="text-xl font-bold" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-211">
                      ARS
                    </span>
                  </div>
                </div>

                <ul className="space-y-3 mb-8 text-left max-w-[280px] mx-auto" data-id="element-212">
                  {['7 recursos completos en un pack', '+500 parábolas con enseñanzas', 'Material listo para imprimir o usar digital', 'Acceso inmediato tras la compra', 'Ideal para casa, iglesia o aula'].map((text, i) => <li key={i} className="flex items-center gap-3" data-id="element-213">
                      <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{
                    backgroundColor: '#F0F7F2'
                  }} data-id="element-214">
                        <Check className="w-3 h-3" style={{
                      color: 'var(--color-green)'
                    }} data-id="element-215" />
                      </div>
                      <span className="text-base font-bold" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-216">
                        {text}
                      </span>
                    </li>)}
                </ul>

                <a href="https://pago.atlasdigitalhub.com/cart/42641209360482:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-center text-lg font-bold text-white rounded-full transition-all duration-300 hover:-translate-y-1" style={{
                backgroundColor: 'var(--color-gold)',
                boxShadow: '0 4px 15px rgba(201,150,59,0.4)'
              }} onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = 'var(--color-gold-hover)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(201,150,59,0.5)';
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'var(--color-gold)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(201,150,59,0.4)';
              }} data-id="element-217">
                  QUIERO LA COLECCIÓN
                </a>

                <p className="mt-4 text-sm font-bold" style={{
                color: 'var(--color-deep-blue)'
              }} data-id="element-218">
                  Más de 400 familias ya lo tienen
                </p>

                <div className="flex items-center justify-center gap-1.5 mt-4 pt-4 border-t" style={{
                borderColor: 'var(--color-border)'
              }} data-id="element-219">
                  <ShieldCheck className="w-4 h-4" style={{
                  color: 'var(--color-green)'
                }} data-id="element-220" />
                  <span className="text-xs font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-221">
                    Pago seguro y garantizado
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}